import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Button, TableHead } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, cloneDeep } from 'lodash';
import { round } from 'mathjs';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import PDF from '../../component/pdf';
import Title from '../../component/title';
import HeadPdf from '../../component/head-pdf';
import FootPdf from '../../component/foot-pdf';
import moIndex from '../../store/index';
import moLeaveRate from './store';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import Chart from './chart';
import LeaveTable from './leave-table';
import Explain from './explain';

interface IProps {}
interface IState {}

const ChartPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const {
    xData, yData, labels,
    tableHead, tableLeft, tableRight,
  } = moLeaveRate;
  const { isMock } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  // 第二个参数 - 保留几位小数
  const newValue = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value === 0) return '0%';
    return `${round(value, digit)}%`;
  };

  const pdfLog = () => {
    const newData: any[] = cloneDeep(moLeaveRate.xData.slice(10));
    const text: any[] = [];
    for (let i = 0; i < Math.ceil(newData.length / 10); i += 1) {
      const firstData = newData.slice(5 * i + 5 * i, 5 * i + 5 * i + 5);
      const secondData = newData.slice(5 * i + 5 * i + 5, 5 * i + 5 * i + 10);

      text.push(
        <PDF key={i}>
          <section className="industry-leave-pdf_1500">
            <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
            <section className="content-1500">
              <section className="title-1001">
                <Title title="行业离职率" bigTitle="人力指标" />
              </section>
              <section className="industry-leave_1500">
                {!isEmpty(xData) ? (
                  <section className="box-1500"
                    style={{ marginTop: 0 }}>
                    <section className={[
                      'box-13', !isMock ? '' : 'mock-100',
                    ].join(' ')}
                    style={{ overflowY: 'auto' }}>
                      <section className="chart-title_03">
                        {labels.map((item: any, idx: number) => (
                          <p key={idx} className="line-03"
                            style={{ marginRight: 0 }}>
                            <strong>{newValue(item?.value)}</strong>
                            <span style={{ marginLeft: '5px' }}>{item?.year}全行业离职率</span>
                          </p>
                        ))}
                      </section>
                      <section>
                        {!isEmpty(firstData) ? (
                          <Chart height={300} idx={i + 1} index={1}
                            xData={firstData} yData={yData} />
                        ) : null}
                        {!isEmpty(secondData) ? (
                          <Chart height={300} idx={i + 1} index={2}
                            xData={secondData} yData={yData} />
                        ) : null}
                      </section>
                    </section>
                  </section>
                ) : (<Empty padding="50px 0" />)}
              </section>
            </section>
            <FootPdf />
          </section>
        </PDF>,
      );
    }
    return text;
  };

  return (
    <>
      <PDF>
        <section className="industry-leave-pdf_1500">
          <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
          <section className="content-1500">
            <section className="title-1001">
              <Title title="行业离职率" bigTitle="人力指标" />
            </section>

            <section className="industry-leave_1500">
              {!isEmpty(xData) ? (
                <section className="box-1500"
                  style={{ marginTop: 0 }}>
                  <section className={[
                    'box-13', !isMock ? '' : 'mock-100',
                  ].join(' ')}
                  style={{ overflowY: 'auto' }}>
                    <section className="chart-title_03">
                      {labels.map((item: any, idx: number) => (
                        <p key={idx} className="line-03"
                          style={{ marginRight: 0 }}>
                          <strong>{newValue(item?.value)}</strong>
                          <span style={{ marginLeft: '5px' }}>{item?.year}全行业离职率</span>
                        </p>
                      ))}
                    </section>
                    <section>
                      <Chart height={300} idx={0} index={0}
                        xData={xData.slice(0, 5)} yData={yData} />
                      {xData.length > 5 ? (
                        <Chart height={300} idx={1} index={0}
                          xData={xData.slice(5, 10)} yData={yData} />
                      ) : null}
                    </section>
                  </section>
                </section>
              ) : (<Empty padding="50px 0" />)}
            </section>

            {(xData.length <= 5 && xData.length > 0) ? (
              <LeaveTable tableHead={tableHead} tableLeft={tableLeft} tableRight={tableRight} />
            ) : null}
            {(xData.length <= 5 && xData.length > 0) ? <Explain /> : null}
          </section>
          <FootPdf />
        </section>
      </PDF>

      {xData.length > 10 ? pdfLog() : null}
    </>
  );
};

export default observer(ChartPDF);
